const leadOperationType = {
  Export: 'export',
  Distribution: 'distribution',
  Update: 'update'
}

export default leadOperationType
